import styled from 'styled-components';

export const Wrapper = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  align-items: flex-end;
  pointer-events: none;
  transform: ${props => (props.isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-out;
`;

export const List = styled.div<{ width: string; minWidth: string }>`
  box-shadow: 0 16px 32px rgba(44, 53, 86, 0.15);
  width: ${props => props.width};
  min-width: ${props => props.minWidth};
  margin: 0;
  padding: 0;
  pointer-events: initial;
  background: var(--white);
`;
